module.exports = __webpack_public_path__ + "static/img/bar-wrapper.7f58b01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/event/Christmas2020/bar-wrapper.png
// module id = 1HbK
// module chunks = 1